import { logger } from "./Logger";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

// Conversions are fired once per browser session. Without this, a user who
// refreshes /skills after signing up would report a second StartTrial.
const FIRED_KEY = "futTrackedConversions";

const alreadyFired = eventName => {
  try {
    const fired = JSON.parse(window.sessionStorage.getItem(FIRED_KEY) || "[]");
    return fired.includes(eventName);
  } catch (e) {
    return false;
  }
};

const markFired = eventName => {
  try {
    const fired = JSON.parse(window.sessionStorage.getItem(FIRED_KEY) || "[]");
    window.sessionStorage.setItem(
      FIRED_KEY,
      JSON.stringify(fired.concat(eventName))
    );
  } catch (e) {
    // sessionStorage unavailable (private mode, blocked cookies). The event
    // still fires — we just lose de-duplication.
  }
};

/**
 * Load the Meta Pixel. Called once on app boot from index.js.
 *
 * The www marketing site loads its pixel through GTM (container GTM-PDJ3VK),
 * but the web app has no GTM container, so the pixel is loaded directly here.
 * Both use the same pixel ID, and fbevents.js scopes its _fbp / _fbc cookies
 * to followupthen.com, so a click landing on www carries its attribution
 * across to app.followupthen.com without threading fbclid through the URL.
 */
export const initMetaPixel = () => {
  if (!PIXEL_ID) {
    logger.log("initMetaPixel: no REACT_APP_META_PIXEL_ID set", {
      level: "warn"
    });
    return;
  }
  if (typeof window === "undefined" || window.fbq) return;

  /* eslint-disable */
  !(function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

/**
 * Report a conversion to Meta (and to GTM's dataLayer if a container is ever
 * added to this app — sendGtmEvent in utils.js is currently a no-op here).
 *
 * @param {string} eventName Standard Meta event, e.g. "StartTrial"
 * @param {object} params Optional event params (value, currency, etc.)
 * @param {object} options { once: false } to allow repeat fires in a session
 */
export const trackConversion = (eventName, params = {}, options = {}) => {
  const { once = true } = options;

  if (once && alreadyFired(eventName)) return;

  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", eventName, params);
    if (once) markFired(eventName);
    logger.log(`conversion tracked: ${eventName}`, { data: params });
  } else {
    logger.log(`trackConversion: pixel unavailable for ${eventName}`, {
      level: "warn"
    });
  }

  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({ event: eventName, ...params });
  }
};
